import { render, staticRenderFns } from "./last.vue?vue&type=template&id=83b02cb4"
import script from "./last.vue?vue&type=script&lang=js"
export * from "./last.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b02cb4')) {
      api.createRecord('83b02cb4', component.options)
    } else {
      api.reload('83b02cb4', component.options)
    }
    module.hot.accept("./last.vue?vue&type=template&id=83b02cb4", function () {
      api.rerender('83b02cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/we/last.vue"
export default component.exports